import { hasRoles, navSection, requiredRolesForPath } from 'utils/accessPolicy'

export let statementLinks = [
  {
    key: 'constants.sidebar.createStatement',
    text: 'Создать заявление',
    to: '/create-statement',
  },
  {
    key: 'constants.sidebar.statementHistory',
    text: 'История заявлений',
    to: '/statement-history',
  },
  {
    key: 'constants.sidebar.statementStatus',
    text: 'Статус заявлений',
    to: '/statements',
  },
]
export let taskLinks = [
  {
    key: 'constants.sidebar.addTask',
    text: 'Добавить задачу',
    to: '/create-task',
  },
  {
    key: 'constants.sidebar.myTasks',
    text: 'Мои задачи',
    to: '/tasks',
  },
]

export const ROLE_CODES = {
  STUDENT: 'student',
  TEACHER: 'teacher',
  CURATOR: 'curator',
  HEAD_DEPT: 'head_of_department',
  DEAN: 'dean',
  METHODIST: 'methodist',
  HR_STUDENTS: 'hr_students',
  HR_EMPLOYEES: 'hr_employees',
  ACCOUNTANT: 'accountant',
  ARCHIVIST: 'archivist',
  RECTORATE: 'rectorate',
  SYSADMIN: 'sysadmin',
  PARENT: 'parent',
  APPLICANT: 'applicant',
  POSTGRAD: 'postgrad',
  DPO_STUDENT: 'dpo_student',
  FOREIGN_STUDENT: 'foreign_student',
  DORM_STAFF: 'dorm_staff',
  PROCTOR: 'proctor',
}

const R = ROLE_CODES

// Удобные семантические группы для повторного использования.
const ALL_STUDENTS = [R.STUDENT, R.FOREIGN_STUDENT, R.POSTGRAD, R.DPO_STUDENT]
const ALL_TEACHERS = [R.TEACHER, R.CURATOR, R.HEAD_DEPT, R.DEAN, R.METHODIST]
const ADMIN_TIER = [R.METHODIST, R.DEAN, R.HEAD_DEPT, R.RECTORATE, R.SYSADMIN]
const HR_TIER = [R.HR_STUDENTS, R.HR_EMPLOYEES, R.METHODIST, R.DEAN, R.RECTORATE, R.SYSADMIN]
const ALL_AUTHED = [
  R.STUDENT, R.TEACHER, R.CURATOR, R.HEAD_DEPT, R.DEAN, R.METHODIST,
  R.HR_STUDENTS, R.HR_EMPLOYEES, R.ACCOUNTANT, R.ARCHIVIST,
  R.RECTORATE, R.SYSADMIN, R.PARENT, R.APPLICANT,
  R.POSTGRAD, R.DPO_STUDENT, R.FOREIGN_STUDENT, R.DORM_STAFF, R.PROCTOR,
]

// P1-V1: пункты главной — у applicant своя страница (/applicant-home/),
// у всех остальных — общая /home/. Раньше /home/ висел на roles: [] и
// applicant видел пустую сводку для сотрудников.
const HOME_NON_APPLICANT = [
  R.STUDENT, R.TEACHER, R.CURATOR, R.HEAD_DEPT, R.DEAN, R.METHODIST,
  R.HR_STUDENTS, R.HR_EMPLOYEES, R.ACCOUNTANT, R.ARCHIVIST,
  R.RECTORATE, R.SYSADMIN, R.PARENT,
  R.POSTGRAD, R.DPO_STUDENT, R.FOREIGN_STUDENT, R.DORM_STAFF, R.PROCTOR,
]

export const universalSidebar = [
  // ───────── Стартовая ─────────
  { key: 'menu.home', text: 'Главная', to: '/home/', roles: HOME_NON_APPLICANT },
  // P1-A1: applicant-роль получает собственный домашний экран с карточками
  // «Подать заявление / Статус приёма / Документы».
  {
    key: 'menu.applicantHome',
    text: 'Главная абитуриента',
    to: '/applicant-home/',
    roles: [R.APPLICANT],
  },

  // ───────── Учебный процесс (студентам и преподам) ─────────
  {
    key: 'menu.schedule',
    text: 'Расписание',
    to: '/schedule/',
    roles: [...ALL_STUDENTS, ...ALL_TEACHERS, R.PARENT],
  },
  {
    key: 'menu.scheduleBuilder',
    text: 'Конструктор расписания',
    to: '/schedule-builder/',
    roles: [R.METHODIST, R.DEAN, R.HEAD_DEPT, R.RECTORATE, R.SYSADMIN],
  },
  {
    key: 'menu.scheduleImport',
    text: 'Импорт расписания',
    to: '/schedule-import/',
    roles: [R.METHODIST, R.DEAN, R.HEAD_DEPT, R.RECTORATE, R.SYSADMIN],
  },
  {
    key: 'menu.mySyllabus',
    text: 'Мой учебный план',
    to: '/my-syllabus/',
    roles: [...ALL_STUDENTS, R.PARENT, R.TEACHER, R.CURATOR],
  },
  {
    key: 'menu.syllabus',
    text: 'Учебные планы',
    to: '/syllabuses/',
    roles: ADMIN_TIER,
  },
  {
    key: 'menu.syllabusBuilder',
    text: 'Конструктор учебного плана',
    to: '/syllabus-builder/',
    roles: [R.METHODIST, R.DEAN, R.RECTORATE, R.SYSADMIN],
  },
  {
    key: 'menu.syllabusApproval',
    text: 'Утверждение УП',
    to: '/syllabus-approval/',
    roles: [R.METHODIST, R.HEAD_DEPT, R.DEAN, R.RECTORATE, R.SYSADMIN],
  },
  {
    key: 'menu.journal',
    text: 'Журнал',
    to: '/journal/',
    roles: [...ALL_STUDENTS, ...ALL_TEACHERS],
  },
  {
    key: 'menu.gradebook',
    text: 'Зачётка',
    to: '/gradebook/',
    roles: [...ALL_STUDENTS, ...ALL_TEACHERS],
  },
  { key: 'menu.studentFinance', text: 'Мои финансы', to: '/student-finance/', roles: ALL_STUDENTS },
  {
    key: 'constants.sidebar.childPerformance',
    text: 'Успеваемость ребёнка',
    to: '/gradebook/?for=child',
    roles: [R.PARENT],
  },
  {
    key: 'menu.absenceJustification',
    text: 'Оправдательные документы',
    to: '/absence-justification/',
    roles: [...ALL_STUDENTS, R.CURATOR, R.DEAN, R.METHODIST, R.HEAD_DEPT],
  },
  {
    key: 'menu.assignments',
    text: 'Задания',
    to: '/assignments-list/',
    roles: [...ALL_STUDENTS, R.TEACHER, R.METHODIST, R.DEAN, R.CURATOR, R.HEAD_DEPT],
  },
  {
    key: 'menu.tests',
    text: 'Тесты',
    to: '/tests/',
    roles: [...ALL_STUDENTS, R.TEACHER, R.METHODIST, R.HEAD_DEPT, R.SYSADMIN],
  },
  {
    key: 'menu.testBuilder',
    text: 'Конструктор тестов',
    to: '/test-builder/',
    roles: [R.TEACHER, R.METHODIST, R.HEAD_DEPT, R.SYSADMIN],
  },
  {
    key: 'menu.questionBank',
    text: 'Банк вопросов',
    to: '/question-bank/',
    roles: [R.TEACHER, R.METHODIST, R.HEAD_DEPT, R.SYSADMIN],
  },
  {
    key: 'menu.surveys',
    text: 'Анкеты',
    to: '/surveys/',
    roles: [...ALL_STUDENTS, R.TEACHER, R.METHODIST, R.RECTORATE, R.SYSADMIN],
  },
  {
    key: 'menu.statements',
    text: 'Заявления',
    to: '/statements/',
    roles: [...ALL_STUDENTS, ...ALL_TEACHERS, R.HR_STUDENTS, R.HR_EMPLOYEES, R.ACCOUNTANT, R.ARCHIVIST, R.RECTORATE, R.SYSADMIN],
  },
  {
    key: 'constants.sidebar.workTasks',
    text: 'Задачи',
    to: '/tasks/',
    roles: ALL_AUTHED,
  },
  {
    key: 'menu.notes',
    text: 'Заметки',
    to: '/notes/',
    roles: ALL_AUTHED,
  },
  { text: 'Хозяйственные заявки', to: '/work-requests/', roles: ALL_AUTHED.filter((role) => ![...ALL_STUDENTS, R.PARENT, R.APPLICANT].includes(role)) },
  {
    key: 'menu.calendar',
    text: 'Календарь',
    to: '/calendar/',
    roles: ALL_AUTHED,
  },
  {
    key: 'menu.chats',
    text: 'Чаты',
    to: '/chats/',
    roles: ALL_AUTHED,
  },

  // ───────── Преподаватель (специфика) ─────────
  {
    key: 'menu.myDisciplines',
    text: 'Мои дисциплины',
    to: '/my-disciplines/',
    roles: [R.TEACHER],
  },
  {
    key: 'constants.sidebar.teacherStatements',
    text: 'Ведомости',
    to: '/teacher-statements/',
    roles: [R.TEACHER, R.METHODIST, R.DEAN, R.HEAD_DEPT],
  },
  {
    key: 'constants.sidebar.workload',
    text: 'Нагрузка',
    to: '/workload/',
    roles: [R.TEACHER, R.HEAD_DEPT, R.DEAN, R.METHODIST],
  },
  {
    key: 'menu.science',
    text: 'Наука',
    to: '/science/',
    roles: [R.TEACHER, R.HEAD_DEPT, R.DEAN, R.METHODIST, R.RECTORATE, R.SYSADMIN],
  },

  // ───────── Куратор ─────────
  {
    key: 'menu.curatorDrilldown',
    text: 'Детализация по группе',
    to: '/curator-drilldown/',
    roles: [R.TEACHER, R.CURATOR, R.DEAN, R.METHODIST, R.HEAD_DEPT, R.RECTORATE, R.SYSADMIN],
  },

  // ───────── Сессии и отчёты ─────────
  {
    key: 'menu.sessions',
    text: 'Сессии',
    to: '/sessions/',
    roles: [R.METHODIST, R.DEAN, R.HEAD_DEPT, R.RECTORATE, R.SYSADMIN],
  },
  {
    key: 'menu.reports',
    text: 'Отчёты',
    to: '/reports/',
    roles: [R.TEACHER, R.CURATOR, R.METHODIST, R.DEAN, R.HEAD_DEPT, R.HR_STUDENTS, R.HR_EMPLOYEES, R.ACCOUNTANT, R.ARCHIVIST, R.RECTORATE, R.SYSADMIN],
  },
  {
    key: 'menu.deanDashboard',
    text: 'Дашборд факультета',
    to: '/dean-dashboard/',
    roles: [R.DEAN, R.RECTORATE, R.SYSADMIN],
  },
  {
    key: 'constants.sidebar.dashboard',
    text: 'Дашборд',
    to: '/admin/',
    roles: [R.METHODIST, R.DEAN, R.HEAD_DEPT, R.HR_STUDENTS, R.HR_EMPLOYEES, R.ACCOUNTANT, R.RECTORATE, R.SYSADMIN],
  },

  // ───────── Кадры и студенты (HR) ─────────
  { key: 'menu.admissionApplications', text: 'Приёмная комиссия', to: '/admission-applications/', roles: [R.HR_STUDENTS, R.HR_EMPLOYEES] },
  {
    key: 'menu.students',
    text: 'Студенты',
    to: '/students-list/',
    roles: [R.HR_STUDENTS, R.METHODIST, R.DEAN, R.HEAD_DEPT, R.CURATOR, R.RECTORATE, R.SYSADMIN],
  },
  {
    key: 'menu.employees',
    text: 'Сотрудники',
    to: '/employees/',
    roles: [R.HR_EMPLOYEES, R.HEAD_DEPT, R.DEAN, R.RECTORATE, R.SYSADMIN],
  },
  // P1-V1: мастер найма был в routes.js, но в сайдбар не попадал.
  {
    key: 'menu.employeeWizard',
    text: 'Мастер найма сотрудника',
    to: '/employee-wizard/',
    roles: [R.HR_EMPLOYEES, R.RECTORATE, R.SYSADMIN],
  },
  {
    key: 'menu.admission',
    text: 'Приём',
    to: '/admission/',
    roles: [R.HR_STUDENTS, R.RECTORATE, R.SYSADMIN],
  },
  {
    key: 'menu.transfers',
    text: 'Переводы',
    to: '/transfers/',
    roles: [R.HR_STUDENTS, R.METHODIST, R.DEAN, R.RECTORATE, R.SYSADMIN],
  },
  {
    key: 'menu.orders',
    text: 'Приказы',
    to: '/orders/',
    roles: [R.HR_STUDENTS, R.HR_EMPLOYEES, R.METHODIST, R.DEAN, R.HEAD_DEPT, R.RECTORATE, R.SYSADMIN],
  },
  {
    key: 'menu.groups',
    text: 'Группы',
    to: '/groups/',
    roles: [R.METHODIST, R.DEAN, R.HEAD_DEPT, R.CURATOR, R.RECTORATE, R.SYSADMIN],
  },
  { text: 'Структура учреждения', to: '/institution-structure/', roles: [R.METHODIST, R.DEAN, R.HEAD_DEPT, R.RECTORATE, R.SYSADMIN] },

  // ───────── Финансы ─────────
  {
    key: 'menu.accounting',
    text: 'Бухгалтерия',
    to: '/accounting/',
    roles: [R.ACCOUNTANT, R.RECTORATE, R.SYSADMIN],
  },

  // ───────── Архив ─────────
  {
    key: 'menu.archive',
    text: 'Архив',
    to: '/archive/',
    roles: [R.ARCHIVIST, R.HR_STUDENTS, R.HR_EMPLOYEES, R.METHODIST, R.DEAN, R.RECTORATE, R.SYSADMIN],
  },
  {
    key: 'menu.ocrSearch',
    text: 'OCR-поиск по архиву',
    to: '/archive/ocr-search/',
    roles: [R.ARCHIVIST, R.RECTORATE, R.SYSADMIN],
  },
  {
    key: 'menu.orderArchiveLink',
    text: 'Связь приказов с архивом',
    to: '/archive/order-link/',
    roles: [R.ARCHIVIST, R.RECTORATE, R.SYSADMIN],
  },

  // ───────── Универсальные сервисы ─────────
  { key: 'menu.library', text: 'Библиотека', to: '/library/', roles: [] },
  {
    key: 'menu.dorm',
    text: 'Общежитие',
    to: '/dorm/',
    roles: [
      R.STUDENT, R.FOREIGN_STUDENT, R.POSTGRAD, R.DPO_STUDENT,
      R.DORM_STAFF, R.HR_STUDENTS, R.HR_EMPLOYEES, R.ACCOUNTANT, R.RECTORATE, R.SYSADMIN,
    ],
  },
  {
    key: 'menu.practice',
    text: 'Практика',
    to: '/practice/',
    roles: [...ALL_STUDENTS, R.TEACHER, R.METHODIST, R.DEAN, R.HEAD_DEPT],
  },
  {
    key: 'menu.diploma',
    text: 'ВКР',
    to: '/diploma/',
    roles: [...ALL_STUDENTS, R.TEACHER, R.METHODIST, R.DEAN, R.HEAD_DEPT],
  },
  {
    key: 'menu.distance',
    text: 'Дистанционное обучение',
    to: '/distance/',
    roles: [...ALL_STUDENTS, R.TEACHER, R.METHODIST, R.DEAN, R.HEAD_DEPT],
  },
  {
    key: 'menu.career',
    text: 'Карьера',
    to: '/career/',
    roles: [...ALL_STUDENTS, R.TEACHER, R.DEAN, R.HR_STUDENTS, R.HR_EMPLOYEES, R.RECTORATE, R.SYSADMIN],
  },
  {
    key: 'menu.studentLife',
    text: 'Студенческая жизнь',
    to: '/student-life/',
    roles: [...ALL_STUDENTS, R.CURATOR, R.TEACHER, R.DEAN, R.HR_STUDENTS, R.HR_EMPLOYEES, R.METHODIST, R.RECTORATE, R.SYSADMIN],
  },
  {
    key: 'menu.plagiarism',
    text: 'Плагиат',
    to: '/plagiarism/',
    roles: [R.TEACHER, R.METHODIST, R.DEAN, R.RECTORATE, R.SYSADMIN],
  },

  // ───────── Спец-категории студентов ─────────
  {
    key: 'menu.postgrad',
    text: 'Аспирантура',
    to: '/postgrad/',
    roles: [R.POSTGRAD, R.HR_STUDENTS, R.HR_EMPLOYEES, R.METHODIST, R.DEAN, R.RECTORATE, R.SYSADMIN],
  },
  {
    key: 'menu.dpo',
    text: 'ДПО',
    to: '/dpo/',
    roles: [...ALL_STUDENTS, R.HR_STUDENTS, R.HR_EMPLOYEES, R.METHODIST, R.RECTORATE, R.SYSADMIN],
  },
  {
    key: 'menu.foreignStudents',
    text: 'Иностранные студенты',
    to: '/foreign-students/',
    roles: [R.FOREIGN_STUDENT, R.HR_STUDENTS, R.METHODIST, R.DEAN, R.RECTORATE, R.SYSADMIN],
  },
  {
    key: 'menu.military',
    text: 'Военный учёт',
    to: '/military-students/',
    roles: [R.HR_STUDENTS, R.METHODIST, R.RECTORATE, R.SYSADMIN],
  },

  // ───────── Структура и админ ─────────
  {
    key: 'menu.structure',
    text: 'Структура',
    to: '/structure/',
    roles: ALL_AUTHED,
  },
  {
    key: 'menu.admin',
    text: 'Админ-панель',
    to: '/admin/',
    roles: [R.RECTORATE, R.SYSADMIN],
  },
  {
    key: 'menu.integrations',
    text: 'Интеграции',
    to: '/admin/integrations/',
    roles: [R.RECTORATE, R.SYSADMIN],
  },
  {
    key: 'menu.services',
    text: 'Сервисы',
    to: '/admin/services/',
    roles: [R.RECTORATE, R.SYSADMIN],
  },

  // ───────── Помощь (всегда) ─────────
  { key: 'menu.help', text: 'Помощь', to: '/help/', roles: [] },
]

export function filterSidebarByRoles(roleCodes = [], options = {}) {
  const codes = new Set(
    (roleCodes || []).map((r) => (typeof r === 'string' ? r : r?.code)),
  )
  // is_superuser → даём ему такие же права видимости, как у sysadmin,
  // но НЕ открываем все пункты подряд: суперюзер должен видеть только то,
  // что относится к админу (плюс универсальные пункты без ролей).
  if (options.isSuper) {
    codes.add(ROLE_CODES.SYSADMIN)
  }
  // Пункты, которые никому из админов не нужны (явно для студентов/учителей и т.п.)
  // прячем для суперадмина даже если они без roles.
  const isAdminOnlyView =
    options.isSuper ||
    codes.has(ROLE_CODES.SYSADMIN) ||
    codes.has(ROLE_CODES.RECTORATE)
  const ADMIN_HIDE_UNIVERSAL = new Set(['/library/', '/my-disciplines/', '/my-syllabus/', '/gradebook/', '/journal/', '/tests/', '/test-builder/', '/question-bank/', '/surveys/', '/curator-drilldown/', '/dean-dashboard/'])
  const MANAGEMENT_NAV = new Set(['/home/', '/admin/', '/students-list/', '/employees/', '/admission/', '/admission-applications/', '/transfers/', '/orders/', '/employee-wizard/', '/institution-structure/', '/groups/', '/syllabuses/', '/syllabus-builder/', '/syllabus-approval/', '/schedule/', '/schedule-builder/', '/schedule-import/', '/sessions/', '/dorm/', '/dpo/', '/postgrad/', '/student-life/', '/career/', '/reports/', '/accounting/', '/archive/', '/structure/', '/tasks/', '/statements/', '/calendar/', '/chats/', '/notes/', '/work-requests/', '/admin/integrations/', '/admin/services/', '/help/'])
  const seen = new Set()
  return universalSidebar.filter((item) => {
    if (seen.has(item.to)) return false
    if (isAdminOnlyView && !MANAGEMENT_NAV.has(item.to)) return false
    if (isAdminOnlyView && ADMIN_HIDE_UNIVERSAL.has(item.to)) return false
    const required = requiredRolesForPath(item.to) || item.roles
    // Parents use their linked student's read-only screens, never staff workflows.
    if (codes.has(R.PARENT) && codes.size === 1 && ['/statements/', '/tasks/', '/notes/', '/calendar/', '/chats/', '/structure/'].includes(item.to)) return false
    if (!required || required.length === 0) {
      seen.add(item.to)
      return true
    }
    const allowed = hasRoles([...codes], required, options.isSuper && MANAGEMENT_NAV.has(item.to))
    if (allowed) {
      seen.add(item.to)
      return true
    }
    return false
  }).map((item) => ({ ...item, section: navSection(item.to) }))
}
